import React from 'react'
import sanitizeHtml from 'sanitize-html'

export function InnerHTML2React (innerHTML) {
  return <div dangerouslySetInnerHTML={{
    __html: sanitizeHtml(innerHTML, {
      allowedClasses: {
        '*': ['*']
      },
      allowedAttributes: {
        '*': ['data-*', 'name'],
        a: ['href', 'name', 'target'],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading']
      }
    })
  }}></div>
}
